import { useContext, useState } from 'react';
import { Button, Grid, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getStyles } from './Footer.style';
import FAQModal from '../../FAQ/FAQ';
import { LocalizationContext } from '@context/LocalizationContext';
import { refineFonts } from '@/Theming/refineFonts';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

interface INavBarComponentProps {}

export default function FooterComponent(props: INavBarComponentProps) {
	const [isFAQModalOpen, setIsFAQModalOpen] = useState(false);
	const { NavBar: Text } = useContext(LocalizationContext);
	const theme = useTheme();
	const { trackRefineEvent } = useAnalytics();

	const lessThanSmall = useMediaQuery(theme.breakpoints.down('sm'));
	const styles = getStyles({ theme });

	const handleFAQModalOpen = () => {
		setIsFAQModalOpen(true);
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.FAQ_OPENED);
	};

	return (
		<>
			<FAQModal isOpen={isFAQModalOpen} setIsOpen={setIsFAQModalOpen} />
			<Grid
				paddingInline={{
					xxs: '24px',
					xs: '24px',
					sm: '48px',
					md: '105px',
					lg: '350px',
					xl: '403px',
				}}
				paddingBottom={'16px'}
				container
				sx={styles.footer}
				justifyContent={'space-between'}
				alignItems={'center'}>
				<Grid size="auto">
					<Button data-cy={'pqFaqButton'} variant={'text'} sx={styles.faqButton} onClick={handleFAQModalOpen}>
						{(lessThanSmall ? Text.MobileFaqButton : Text.DesktopFaqButton) ?? 'FAQ'}
					</Button>
				</Grid>
				<Grid size="auto">
					<Stack whiteSpace={'nowrap'} direction="row" gap={'4px'}>
						<Typography
							color={'textSecondary'}
							data-cy={'pqPoweredByText'}
							sx={{ ...refineFonts.smallRegular }}>
							{Text.PoweredBy ?? 'Powered by'}
						</Typography>
						<Typography sx={{ ...refineFonts.smallBold }} color={'textSecondary'}>
							Refine Intelligence
						</Typography>
					</Stack>
				</Grid>
			</Grid>
		</>
	);
}
